window.Notification = {
	
	toggleDetail : function(notifitm, forceReload){
		forceReload = forceReload === undefined ? false : forceReload;
		
		if($("#notif-"+notifitm+" .headnotif-detail").html() == '' || forceReload){
			$("#notif-"+notifitm+" .headnotif-header .name").append('<i class="fa fa-circle-o-notch fa-spin fa-gray" style="font-size:10px;margin-left:10px;"></i>');
			switch(notifitm) {
				case 'email' :
					MyFacture.post("email", {action: "notifDetail"}, function (data) {
						if(data.notifEmail == null) {
							Utils.relocate('?_f=emails');
						} else {
							$("#notif-" + notifitm + " .headnotif-detail").html(data.notifEmail);
							Notification.toggleDown(notifitm);
						}
					}, "json");
					break;
				case 'stock' :
					MyFacture.post("stock_ajax", {action: "stockAlert"}, function (data) {
						$("#notif-" + notifitm + " .headnotif-detail").html(data.stock_stockAlert);
						Notification.toggleDown(notifitm);
					}, "json");
					break;
				case 'support' :
					MyFacture.post("support_tickets", {action: "notifDetail"}, function (data) {
						$("#notif-" + notifitm + " .headnotif-detail").html(data.notifSupport);
						Notification.toggleDown(notifitm);
					}, "json");
					break;
				case 'expenses' :
					MyFacture.post("expenses_expenses", {action: "expensesAlert"}, function (data) {
						$("#notif-" + notifitm + " .headnotif-detail").html(data.expenses_expensesAlert);
						Notification.toggleDown(notifitm);
					}, "json");
					break;
				case 'pos' :
					
					MyFacture.post("pos_cashtills", {action: "offlineTills"}, function (data) {
						$("#notif-" + notifitm + " .headnotif-detail").html(data.pos_cashtillsAlerts);
						Notification.toggleDown(notifitm);
					}, "json");
					break;
				case 'timetracking' :
					
					MyFacture.post("timetracking_timer", {action: "timerAlertList"}, function (data) {
						$("#notif-" + notifitm + " .headnotif-detail").html(data.htmlContent);
						Notification.toggleDown(notifitm);
						
						var timers = [];
						var nbtimers = $('.qtip .oneTimer .timerTimer').length;

						$('.qtip #notif-timetracking .label span').html(nbtimers);
						if (nbtimers > 0) {
							$('.qtip #notif-timetracking .label span').removeClass('spanLabel-green').addClass('spanLabel-orange');
						} else {
							$('.qtip #notif-timetracking .label span').removeClass('spanLabel-orange').addClass('spanLabel-green');
						}

						$.each($('.oneTimer .timerTimer'), function () {
							var me = $(this);
							if (me.attr('running') == "Y") {
								TimetrackingEntryTimer.startTimer(me.attr('timerid'), 'Y');
							}

							me.closest('li').find('.startAndStop').off('click').on('click', function () {
								if (TimetrackingEntryTimer.timers[me.attr('timerid')] != undefined) {
									TimetrackingEntryTimer.stopTimer(me.attr('timerid'), 'N');
								} else {
									TimetrackingEntryTimer.startTimer(me.attr('timerid'), 'N');
								}
							});
						});
					}, "json");
					
					break;
				case 'recurring':
					MyFacture.post("recurring_listing", {action: "occurrencesNotifs"}, function (data) {
						$("#notif-" + notifitm + " .headnotif-detail").html(data.htmlContent);
						Notification.toggleDown(notifitm);
					}, "json");
					break;
			}
		}else{
			
			if($("#notif-"+notifitm+" .headnotif-detail").css('display') != 'block'){
				$("#notif-"+notifitm+" .headnotif-detail").slideDown();
				$("#notif-"+notifitm+" .headnotif-header").addClass('current');
				$(".headnotif:not(#notif-"+notifitm+") .headnotif-header").removeClass('current');
				$(".headnotif:not(#notif-"+notifitm+") .headnotif-detail").slideUp();
			}else{
				$("#notif-"+notifitm+" .headnotif-detail").slideUp();
				$("#notif-"+notifitm+" .headnotif-header").removeClass('current');
			}
		}
	},
	
	toggleDown : function(notifitm){
		$(".headnotif:not(#notif-"+notifitm+") .headnotif-header").removeClass('current');
		$("#notif-" + notifitm + " .headnotif-header").addClass('current');
		
		$("#notif-" + notifitm + " .headnotif-header .name i").remove();
		
		$("#notif-" + notifitm + " .headnotif-detail").slideDown();
		$(".headnotif:not(#notif-" + notifitm + ") .headnotif-detail").slideUp();
	},


	show : function(name){
		MyWindow.load('/notifications/' + name, {}, {
			dialogClass: "white no-title",
			close: function () {
				Notification.snooze(name, 3600 * 22);
			},
			width: 680,
			buttons: []
		}, undefined, 'notification', undefined, 'GET', false);
	},
	
	snooze : function(name, expiration){

		$.ajax({
			url         : '/notifications/'+name,
			type        : 'PUT',
			data 		: {
				expiration : expiration
			},
			dataType    : 'json',
			async       : false,
			success     : function(){
				MyWindow.close('notification');
			}
		});

	}

};
